import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=3800397d&scoped=true&"
import script from "./Splash.vue?vue&type=script&lang=js&"
export * from "./Splash.vue?vue&type=script&lang=js&"
import style1 from "./Splash.vue?vue&type=style&index=1&id=3800397d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800397d",
  null
  
)

export default component.exports